import { useAuthStore } from '../../../store';
import HeaderFilter from '../../../components/HeaderFilter';
import DisplayTable from '../../../components/core/DisplayTable';
import GenericForm from '../../../components/core/GenericForm';

// Admin / Configuration — Companies (SBU) master.
const CompaniesPage = () => {
  const api = '/companies';
  const moduleName = 'Companies';
  const { user } = useAuthStore();
  const isAdmin = user?.role === 'ROLE_ADMIN';
  return (
    <div className={'page-wrapper'}>
      <HeaderFilter showCreate={isAdmin} />
      <DisplayTable
        api={api}
        moduleName={moduleName}
        canDelete={isAdmin}
        canEdit={isAdmin}
        userRole={user?.role}
      />
      <GenericForm api={api} moduleName={moduleName} />
    </div>
  );
};

export default CompaniesPage;
